import { ActionButton } from '@/components/Shared/Buttons';
import { CheckmarkIcon } from '@/styles/Icons/Checkmark';
import { CopyDesignIcon } from '@/styles/Icons/CopyDesign';
import { EditIcon } from '@/styles/Icons/Edit';
import IconBin from '@/styles/Icons/GarbageBin';
import Preview from '@/styles/img/preview.jpg';
import { useNavigate } from 'react-router-dom';

import {
  deleteDesign,
  startDesignerWithACopy,
  startEditingDesign
} from '@/store/designer/operations';
import {
  useActiveProfile,
  useTokenState
} from '@/store/localStorage/useTokenState';
import { selectActiveProfileAugmented } from '@/store/user/selectors/selectActiveProfileAugmented';
import { updateProfileSetting } from '@/store/user/thunks/updateProfileSetting';
import { useDispatch, useSelector } from 'react-redux';

export function DesignItem({ design }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activeProfileId } = useActiveProfile();
  const [token] = useTokenState();
  const profile = useSelector(state =>
    selectActiveProfileAugmented(state, { activeProfileId })
  );

  const isCurrent = design.id === profile.settings.currentDesign;

  function copyDesign() {
    dispatch(startDesignerWithACopy(design.id));
    navigate(`/blog/${profile.blogSlug}`);
  }

  function editDesign() {
    dispatch(startEditingDesign(design.id));
    navigate(`/blog/${profile.blogSlug}`);
  }

  async function handleDeleteDesign() {
    if (window.confirm('Точно удалить дизайн?')) {
      dispatch(deleteDesign({ designId: design.id, token, activeProfileId }));
      if (isCurrent) {
        await dispatch(updateProfileSetting('currentDesign', '0', token));
      }
    }
  }

  if (!design || !design.id) {
    return null;
  }

  return (
    <div key={design.id} className={isCurrent ? 'design current' : 'design'}>
      <span>{design.name}</span>
      {isCurrent ? <CheckmarkIcon /> : ''}
      <div className="design-controls">
        <button title="копировать дизайн" onClick={copyDesign}>
          <CopyDesignIcon />
        </button>
        <button title="редактировать дизайн" onClick={editDesign}>
          <EditIcon />
        </button>
        <button title="удалить дизайн" onClick={handleDeleteDesign}>
          <IconBin />
        </button>
      </div>
      <div className="preview">
        <img src={Preview} width="318px" alt="" />
      </div>
      <div className="action-buttons">
        <ActionButton
          onClick={() =>
            dispatch(updateProfileSetting('currentDesign', design.id, token))
          }
        >
          применить
        </ActionButton>
        {/*<SecondaryButton onClick={this.goToDesignPreview}>
            предпросмотр
    </SecondaryButton>*/}
      </div>
    </div>
  );
}
